import { useQuery } from "@tanstack/react-query";
import CustomFieldsApi from "@/api/custom-fields";
import { CUSTOM_FIELD_CATEGORIES } from "@/pages/Settings/CustomFieldSettings/utils/customFieldConstants";

interface CustomField {
  field_id: number;
  field_name: string;
  editor_type: string;
  description?: string;
  options?: string | string[];
  is_required?: 1 | 0;
  enabled: number;
  type_ids?: number[];
}

export const useCustomFields = () => {
  return useQuery({
    queryKey: [
      "custom_fields",
      "list",
      { category: CUSTOM_FIELD_CATEGORIES.EVIDENCE },
    ],
    queryFn: () =>
      CustomFieldsApi.getCustomFields({
        category: CUSTOM_FIELD_CATEGORIES.EVIDENCE,
      }),
    select: (data) => data?.filter((c: CustomField) => c.enabled === 1),
  });
};

export type { CustomField };
